module.exports = "//static.hsappstatic.net/ContentComponents/static-2.66143/img/blog-post-zero.png"